import { useEffect } from "react";

const setAttr = (selector, attr, value) => document.querySelector(selector)?.setAttribute(attr, value);

const REUNION = { name: "", lat: -21.1151, lng: 55.5364 };

export const usePageMeta = ({ title, description, url, local }) => {
  const place = local || REUNION;
  useEffect(() => {
    document.title = title;
    setAttr('meta[name="description"]', "content", description);
    setAttr('link[rel="canonical"]', "href", url);
    setAttr('meta[property="og:url"]', "content", url);
    setAttr('link[hreflang="fr-RE"]', "href", url);
    setAttr('meta[property="og:title"]', "content", title);
    setAttr('meta[name="geo.placename"]', "content", place.name ? `${place.name}, La Réunion` : "La Réunion");
    setAttr('meta[name="geo.position"]', "content", `${place.lat};${place.lng}`);
    setAttr('meta[name="ICBM"]', "content", `${place.lat}, ${place.lng}`);
    window.scrollTo(0, 0);
  }, [title, description, url, place.name, place.lat, place.lng]);
};
